import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderWorkersDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const isClientPortal = apiData?.portalType === "clientPortal";
      const url = isClientPortal
        ? `${actionType.environment_url}/api/client/GenerateProviderWorkersDocsReport`
        : `${actionType.environment_url}/api/admin/worker/GenerateProviderWorkersDocsReport`;

      const { portalType, ...restParams } = apiData;

      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: url,
        params: {
          ...restParams,
          client_org_ids: JSON.stringify(
            restParams.client_org_ids?.map((item) => item?.organisation_id ?? item)
          ),
          provider_org_ids: JSON.stringify(
            restParams.provider_org_ids?.map((item) => item?.provider_org_id ?? item)
          ),
          worker_ids: JSON.stringify(restParams.worker_ids),
          document_ids: JSON.stringify(restParams.document_ids),
          state_ids: JSON.stringify(restParams.state_ids),
          service_ids: JSON.stringify(restParams.service_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

export const TriggerWorkerChecklistCompRateReport =
  (apiData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/TriggerWorkerChecklistCompRateReport`,
        data: {
          ...apiData,
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id) || []
          ),
          provider_org_ids: JSON.stringify(
            apiData.provider_org_ids?.map((item) => item?.provider_org_id) || []
          ),
          worker_ids: JSON.stringify(apiData.worker_ids || []),
          document_ids: JSON.stringify(apiData.document_ids || []),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };
